import React, { useCallback } from "react";
import { Icon } from "@culturehq/components";
import client from "@culturehq/client";

import { Trans } from "app/utils";

const PinUserActivityToggle = ({ onUserActivityUpdate, userActivity }) => {
  const onClick = useCallback(
    async () => {
      const { id: userActivityId, pinned } = userActivity;

      await client[pinned ? "unpinUserActivity" : "pinUserActivity"]({ userActivityId });
      onUserActivityUpdate({ userActivityId, updates: { pinned: !pinned } });
    },
    [onUserActivityUpdate, userActivity]
  );

  return (
    <button type="button" className="link action" onClick={onClick}>
      <Icon icon={userActivity.pinned ? "pin-outline" : "pin"} />
      {userActivity.pinned ? <Trans>Unpin from feed</Trans> : <Trans>Pin to feed</Trans>}
    </button>
  );
};

export default PinUserActivityToggle;
